import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import {
  BASELINE_DEFAULT_VALUES,
  baselineFormSchema,
} from "./baselineFormConfig";

// Sets up the add/edit baseline form, prefilled from the patient's latest
// baseline reading — editable, and re-synced whenever that latest reading
// changes. A fresh consultation still starts from where the patient's
// vitals last were, not a blank form.
export const useBaselineForm = (baseline) => {
  const form = useForm({
    resolver: zodResolver(baselineFormSchema),
    defaultValues: BASELINE_DEFAULT_VALUES,
  });

  useEffect(() => {
    if (baseline) {
      form.reset(
        Object.fromEntries(
          Object.keys(BASELINE_DEFAULT_VALUES).map((name) => [
            name,
            baseline[name]?.toString() || "",
          ])
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseline]);

  return form;
};
